module.exports = __webpack_public_path__ + "static/media/breadcrumb-arrow.3e1a8747.svg";